import React from 'react';
import { View } from 'react-native';

import { font as initialFont } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { DocumentPreviewIcon } from './documentPreviewIcon';
import Processing from '@v2/components/imageHandling/components/Processing';
import ExtensionLabel from './extensionLabel';
import { scale as initialScale } from '@components/frame';

const Thumbnails = ({
  C,
  item,
  borderRadius,
  CC,
  small,
  alwaysDark,
  scale = initialScale,
  font = initialFont,
  fontName = 'Caption 1',
  width = '100%',
  height = '100%',
  processingContainerStyles,
}) => {
  const shouldApplyDarkModeColors = !!(CC && alwaysDark);

  const bgColor = shouldApplyDarkModeColors ? CC('Button/Dark/Secondary') : C('Button/Light/Secondary');

  return (
    <View
      style={[
        {
          width,
          height,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: bgColor,
        },
        borderRadius != null && { borderRadius },
      ]}
    >
      <DocumentPreviewIcon small={small} C={C} extension={item?.extensionOriginal} scale={scale} />
      <ExtensionLabel item={item} font={font} fontType={fontName} CC={CC} alwaysDark={alwaysDark} />
      {item?.isProcessing && !small && <Processing containerStyles={processingContainerStyles ?? { bottom: scale(15) }} />}
    </View>
  );
};

export default ColorWrapper(Thumbnails);
